// src/js/redesignTabbedAccordion.js
export function redesignTabbedAccordion() {
  const tabbedAccordions = document.querySelectorAll(
    ".redesign-tabbed-accordion, .redesign-tabbed-content",
  );
  tabbedAccordions.forEach((tabbed) => {
    const tabButtons = tabbed.querySelectorAll(".tab-button");
    const tabPanels = tabbed.querySelectorAll(".tab-panel");
    // Tab switching logic
    tabButtons.forEach((btn, idx) => {
      btn.addEventListener("click", function () {
        tabButtons.forEach((b, i) => {
          b.classList.toggle("active-tab", i === idx);
          // Set border color for active tab
          if (i === idx) {
            b.style.borderBottomColor = "var(--primary-orange, #FF5B24)";
          } else {
            b.style.borderBottomColor = "";
          }
          tabPanels[i].classList.toggle("hidden", i !== idx);
        });
        // No need to re-initialize accordions on tab switch; listeners are set once on load
      });
    });
    // Initialize: show first tab
    tabButtons.forEach((b, i) => {
      b.classList.toggle("active-tab", i === 0);
      if (i === 0) {
        b.style.borderBottomColor = "var(--primary-orange, #FF5B24)";
      } else {
        b.style.borderBottomColor = "";
      }
      tabPanels[i].classList.toggle("hidden", i !== 0);
    });
    // Initialize accordions in all tab panels once
    if (typeof window.redesignAccordion === "function") {
      tabPanels.forEach((panel) => {
        window.redesignAccordion(panel);
      });
    }
  });
}
